<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ProfileCard from "./components/ProfileCard.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        style="
          background-image: url(&quot;https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80&quot;);
          margin-right: -24px;
          margin-left: -34%;
        "
      >
        <span class="mask bg-gradient-success opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <img
                  src="../assets/img/team-1.jpg"
                  alt="profile_image"
                  class="shadow-sm w-100 border-radius-lg"
                />
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{ nombreCompleto }}</h5>
                <p class="mb-0 font-weight-bold text-sm">ID: {{ id }}, Fecha de Creación: {{ fechaCreacion }}</p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                  <li class="nav-item">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 40 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>document</title>
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-1870.000000, -591.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(154.000000, 300.000000)">
                                <path
                                  class="color-background"
                                  d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z"
                                  opacity="0.603585379"
                                />
                                <path
                                  class="color-background"
                                  d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">Messages</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Actualizar Perfil</p>
              </div>
            </div>
            <div class="card-body">
              <form role="form" @submit.stop.prevent="sendData">
                <p class="text-uppercase text-sm">Información de Usuario</p>
                <div class="row">
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Username</label
                    >
                    <argon-input type="text" v-model="model.usuario" />
                  </div>
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Email</label
                    >
                    <argon-input type="email" v-model="model.email" />
                  </div>
                </div>
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Información de Contacto</p>
                <div class="row">
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre(s)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="model.nombre"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Apellido Paterno</label
                    >
                    <argon-input type="text" v-model="model.paterno" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Apellido Materno</label
                    >
                    <argon-input type="text" v-model="model.materno" />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Dirección</label
                    >
                    <argon-input type="text" v-model="model.direccion" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Delegación/Municipio</label
                    >
                    <argon-input type="text" v-model="model.delegacion" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Estado</label
                    >
                    <argon-input type="text" v-model="model.estado" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Código Postal</label
                    >
                    <argon-input type="number" v-model="model.cp" />
                  </div>
                </div>
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Telefono</p>
                <div class="row">
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Telefono</label
                    >
                    <argon-input
                      type="number"
                      v-model="model.telefono"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-2">
                    <argon-button
                      v-if="this.formIsValid && formSubmittedError"
                      size="sm"
                      class="ms-auto bg-succes"
                      disabled
                      >No ne</argon-button
                    >
                    <argon-button
                      v-else
                      size="sm"
                      class="ms-auto bg-gray"
                      @submit.prevent="sendData"
                      >Actualizar</argon-button
                    >
                  </div>
                  <div class="col-md-5"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <profile-card :gerente="gerente" />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import usuario from "../api/usuario";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      imageUrl: require("../assets/img/imageLogin.jpeg"), // Utiliza require para importar imágenes en Vue.js
      fechaCreacion: localStorage.getItem("fechaCreacion"),
      id: localStorage.getItem("id"),
      gerente: localStorage.getItem("gerente"),
      nombreCompleto: localStorage.getItem('nombre') + " " + localStorage.getItem("paterno") + " " + localStorage.getItem("materno"),
      model:{
        password: "",
        usuario: localStorage.getItem("usuario"),
        email:localStorage.getItem("email"),
        nombre:localStorage.getItem("nombre"),
        paterno:localStorage.getItem("paterno"),
        materno:localStorage.getItem("materno"),
        direccion: localStorage.getItem("direccion"),
        estado: localStorage.getItem("estado"),
        cp: localStorage.getItem("cp"),
        delegacion: localStorage.getItem("delegacion"),
        telefono: localStorage.getItem("telefono"),
      }
    };
  },
  methods: {
    sendData() {
      usuario
        .logIn(this.model)
        .then((result) => {
          console.log(result.data[0])
          if (result.data[0].id != null) {
            Swal.fire({
              title: "Login Correcto",
              text: "Login correcto",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            localStorage.setItem("id",result.data[0].id)
            localStorage.setItem("gerente",result.data[0].gerente)
            localStorage.setItem("usuario",result.data[0].usuario)
            localStorage.setItem("nivel",result.data[0].nivel)
            localStorage.setItem("nombre",result.data[0].nombre)
            localStorage.setItem("paterno",result.data[0].paterno)
            localStorage.setItem("materno",result.data[0].materno)
            this.$router.push({ path: "/Dashboard" });
          } else {
            Swal.fire({
              title: "Error de Ingreso",
              text: result.data[0],
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.model.usuario = "";
      this.model.password = "";
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>
